import { Breakpoints, styled } from '@volkswagen-onehub/components-core';

export const StyledFooterWelcome = styled.div(
  ({ theme }) => `
    margin-bottom: ${theme.size.static400};
  
    @media (min-width: ${Breakpoints.b1280}px) {
      margin-bottom: ${theme.size.static550};
    }
  `
);
